import earningsSnapshot from './earningsSnapshot';

export default earningsSnapshot;
